
















































































































































































































import Card from '@/components/Card.vue';
import VueGrid from '@liqueflies/vue-flex-grid';
import { Component, Vue } from 'vue-property-decorator';
import VueWordCloud from 'vuewordcloud';
import { Carousel, Slide } from 'vue-carousel';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

Vue.use(VueGrid);

@Component({
  components: {
    Card,
    VueGrid,
    [VueWordCloud.name]: VueWordCloud,
    Carousel,
    Slide,
    FontAwesomeIcon,
  },
  head: {
    title: {
      inner: 'About',
    },
  },
  data: () => {
    return {
      profilePics: [
        {fileName: 'profile1.jpg', altText: 'Winning StartHack 2016'},
        {fileName: 'profile2.jpg', altText: 'Alicia Sykes'},
        {fileName: 'profile3.jpg', altText: 'Teaching at Code School'},
        {fileName: 'profile4.jpg', altText: 'Oxford Half Marathon'},
        {fileName: 'profile5.jpg', altText: 'Winning StartHack 2019'},
        {fileName: 'profile6.jpg', altText: 'Chilton 100 Mile'},
        {fileName: 'profile7.jpg', altText: 'Winning IoT, HackJunction Helsinki'},
        {fileName: 'profile8.jpg', altText: 'Presenting at StartHack Switzerland'},
        {fileName: 'profile9.jpg', altText: 'Winning BlockChain Award, Zurich'},
        {fileName: 'profile10.jpg', altText: 'Alicia Sykes in Oxford'},
      ],
      skillWordsList: [
        ['D3.js', 8], ['Node.js', 9], ['JavaScript', 10], ['Unit Testing', 7], ['React JS', 8],
        ['Angular', 8], ['Vue', 9], ['ES6', 10], ['React Native', 9], ['Native Script', 7],
        ['Kotlin', 8], ['Objective C', 5], ['Java', 8], ['Swift', 7], ['Cordova', 5],
        ['Dart', 7], ['TypeScript', 9], ['Blockchain', 7], ['Neral Networks', 6], ['AI', 8],
        ['NLU', 8], ['Chatbots', 6], ['Apache', 7], ['Linux', 7], ['DevOps', 6],
        ['SQL', 6], ['Mongo', 8], ['Docker', 7], ['AWS', 7], ['Digital Ocean', 8],
        ['NGINX', 7], ['UX', 4], ['Project Management', 5], ['Agile', 6], ['UI', 4],
        ['SCRUM', 6], ['Scaled-Agile', 4], ['Kanban', 4], ['QA', 4],
        ['C++', 5], ['Python', 7], ['C#', 8], ['Ruby', 4], ['PHP', 8], ['C', 4], ['Perl', 4],
        ],
        socialLinks: [
          {title: 'GitHub', icon: 'github', url: 'https://github.com/lissy93' },
          {title: 'StackOverflow', icon: 'stack-overflow', url: 'http://stackoverflow.com/users/979052/lissy' },
          {title: 'LinkedIn', icon: 'linkedin', url: 'http://linkedin.com/in/aliciasykes' },
          {title: 'KeyBase', icon: 'keybase', url: 'https://keybase.io/aliciasykes' },
          {title: 'Twitter', icon: 'twitter', url: 'http://twitter.com/lissy_sykes' },
          {title: 'Instagram', icon: 'instagram', url: 'https://www.instagram.com/' },
          {title: 'Facebook', icon: 'facebook', url: 'http://fb.com/liss.sykes' },
          {title: 'Skype', icon: 'skype', url: 'skype:alicia_sykes?call' },
        ],
      };
  },
})
export default class About extends Vue {}

